import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useStytchMemberSession } from "@stytch/react/b2b";

const MerchantWrapper = () => {
  const { session } = useStytchMemberSession();
  const navigate = useNavigate();
  const location = useLocation();
  const [isInitializing, setIsInitializing] = useState(true);

  // Give Stytch SDK time to initialize on mount
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsInitializing(false);
    }, 1000); // 1 second grace period for SDK to load session

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Skip session check for auth routes (callback)
    // These routes need to handle their own authentication flow
    if (location.pathname.includes('/auth/callback')) {
      return;
    }

    // Don't redirect during initialization period
    if (isInitializing) {
      return;
    }

    if (!session) {
      navigate('/signup');
    }
  }, [session, navigate, location, isInitializing]);

  return (
    <div>
      <Outlet />
    </div>
  );
};

export default MerchantWrapper;
